<template>
  <div class="page">
    <h4 class="text-h4">
      {{ $t("contributions.contributorTable.title") }}
    </h4>
    <list-dialog
      v-model="dialog"
      @hide="dialog = $event"
      :show="dialog"
      :item="item"
      :endpoint="endpoint"
      v-if="dialog"
    ></list-dialog>
    <v-data-table
      class="table"
      :items="items"
      :headers="headers"
      disable-sort
      @click:row="onClickRow"
      :footer-props="footerProps"
      :loading="loading"
    >
      <template v-slot:item.contribution-date="{ item }">
        {{
          $dp.getFromExtension(
            item,
            "http://deeppath.cl/fhir/StructureDefinition/DateOfContributionExt",
            "valueDateTime"
          ) | formatDate
        }}
      </template>
      <template v-slot:item.patient-name>
        {{
          Math.random()
            .toString(36)
            .substring(7)
        }}
      </template>
      <template v-slot:item.diagnose="{ item }">
        {{
          $dp.getFromExtension(
            item,
            "http://deeppath.cl/fhir/StructureDefinition/DiagnoseExt",
            "valueCoding"
          ).system
        }}
      </template>
      <template v-slot:item.tissue-type="{ item }">
        {{
          item.specimenResource.type.coding
            .map(coding => coding["code"])
            .join(" ")
        }}
      </template>
      <template v-slot:item.body-part="{ item }">
        {{ item.specimenResource.collection.bodySite.coding[0].code }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { fetchImagingStudies, fetchOrganizationWithEndpoint } from "@/api/fhir";
import { mapGetters, mapState } from "vuex";
import { SET_CURRENT_SLIDE } from "@/store/modules/annotation";
import ListDialog from "@/components/contributor/ListDialog";

export default {
  components: { ListDialog },
  data() {
    return {
      dialog: false,
      organization: null,
      endpoint: null,
      items: [],
      selected: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({ token: "tokenParsed" }),
    footerProps() {
      return {
        "items-per-page-options": [5, 10, 15],
        "items-per-page-text": this.$t("contributions.contributorTable.footerText")
      }
    },
    headers() {
      return [
        {
          text: this.$t("contributions.contributorTable.id"),
          value: "id"
        },
        {
          text: this.$t("contributions.contributorTable.contributionDate"),
          value: "contribution-date",
          visible: true
        },
        {
          text: this.$t("contributions.contributorTable.patient"),
          value: "patient-name"
        },
        {
          text: this.$t("contributions.contributorTable.diagnose"),
          value: "diagnose"
        },
        {
          text: this.$t("contributions.contributorTable.tissueType"),
          value: "tissue-type"
        },
        {
          text: this.$t("contributions.contributorTable.bodyPart"),
          value: "body-part"
        }
      ]
    }
  },
  methods: {
    async fetchMyOrganization() {
      const identifier = this.token["organization-identifier"];
      const { organization, endpoint } = await fetchOrganizationWithEndpoint(
        identifier,
        "_include=Organization:endpoint",
        "dicom-qido-rs"
      );
      this.organization = organization;
      // if organization has no endpoint yet
      if (!endpoint) {
        throw "Organization has no endpoint yet.";
      }
      this.endpoint = endpoint;
    },
    async fetchMyImagingStudies() {
      console.log(this.organization);
      const { imagingStudy, subjects, specimens } = await fetchImagingStudies(
        null,
        null,
        null,
        this.organization.id,
        null,
        {},
        true
      );
      for (let ii of imagingStudy) {
        ii.specimenResource = specimens.filter(
          specimen =>
            specimen.id == ii.series[0].specimen[0].reference.split("/")[1]
        )[0];
        ii.patientResource = subjects.filter(
          subject => subject.id == ii.subject.reference.split("/")[1]
        )[0];
      }
      this.items = imagingStudy;
      console.log(this.items);
    },
    onClickRow(item) {
      this.item = item;
      this.dialog = true;
    }
  },
  async mounted() {
    this.loading = true;
    try {
      await this.fetchMyOrganization();
      await this.fetchMyImagingStudies();
    } catch (e) {
      // organization has no endpoint yet. forward to registration-wizard
      console.log(e);
      // this.$router.replace({ name: "setup-organization" });
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
